import { Divider, Grid, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import React from 'react';
import { BusinessTypes } from '../../../../enums/business-type';
import { MerchantOnboardingFormValues } from '../../../../type/merchant-onboarding-form-values.types';

interface MerchantInfoProps {
  form: UseFormReturnType<MerchantOnboardingFormValues>;
  businessHandleError: string;
  setBusinessHandleError: React.Dispatch<React.SetStateAction<string>>;
}
function MerchantInfo(props: MerchantInfoProps) {
  const { form, businessHandleError, setBusinessHandleError } = props;
  const label = {
    merchantName: 'Company name',
    merchantBusinessName: 'Registered business name',
    businessHandle: 'Name for payment link',
    merchantCompanyTin: 'Company TIN',
  };
  const placeHolder = {
    merchantName: 'Company name',
    merchantBusinessName: 'Registered business name',
    merchantCompanyTin: 'Company TIN',
  };

  return (
    <>
      <Grid>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.merchantName}
            label={label.merchantName}
            value={form.values.merchantName}
            onChange={(event) => {
              form.setFieldValue('merchantName', event.currentTarget.value);
            }}
            error={form.errors.merchantName}
            data-cy='merchantName'
          />
        </Grid.Col>
        {form.values.businessTypeId !== BusinessTypes.STARTER && (
          <>
            <Grid.Col>
              <TextInput
                placeholder={placeHolder.merchantBusinessName}
                label={label.merchantBusinessName}
                value={form.values.merchantBusinessName}
                onChange={(event) => {
                  form.setFieldValue(
                    'merchantBusinessName',
                    event.currentTarget.value
                  );
                  form.setFieldValue(
                    'businessHandle',
                    event.currentTarget.value
                      .toLowerCase()
                      .replace(/\s/g, '_')
                      .replace(/[^A-Za-z0-9-_]/g, '-')
                  );
                  setBusinessHandleError('');
                }}
                error={form.errors.merchantBusinessName}
                data-cy='merchantBusinessName'
              />
            </Grid.Col>
            <Grid.Col>
              <TextInput
                label={label.businessHandle}
                value={form.values.businessHandle}
                description='A unique identifier where your customers will see this in the
                payment link.'
                error={businessHandleError}
                data-cy='businessHandle'
                disabled
              />
            </Grid.Col>
          </>
        )}

        <Grid.Col>
          <TextInput
            label={label.merchantCompanyTin}
            value={form.values.merchantCompanyTin}
            placeholder={placeHolder.merchantCompanyTin}
            onChange={(event) => {
              form.setFieldValue(
                'merchantCompanyTin',
                event.currentTarget.value
              );
            }}
            error={form.errors.merchantCompanyTin}
            data-cy='merchantCompanyTin'
          />
        </Grid.Col>
        <Grid.Col>
          <Divider my='md' />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MerchantInfo;
